<template>
  <validation-observer v-if="!disabled" ref="observer">
    <div class="bg-secondary-13 p-3">
      <div class="row mb-3">
        <div class="col">
          <em
            class="fas fa-search rounded-circle shadow p-2 color-primary-2 mr-2"
          />
          <span>Búsqueda de Practicantes/Internos/Especialistas</span>
        </div>
      </div>
      <div class="container-fluid mx-4 mb-4">
        <div class="row">
          <div class="col-sm-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="practitionerTypeSelected"
                :clearable="false"
                custom-error-msg="Favor seleccionar el Tipo para realizar la búsqueda"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo:"
                :options="practitionerTypes"
                placeholder="Seleccione"
                @input="getSupervisedSpecialist"
              />
            </validation-provider>
          </div>
          <div class="col-sm-4">
            <custom-input
              v-model="specialistName"
              label="Nombre:"
              placeholder="Escribir Nombre"
            />
          </div>
        </div>
      </div>
      <div v-if="specialists.length > 0">
        <separator class="my-4" text="Resultado de Especialistas" />
        <div
          v-for="specialist in unSelectedSpecialistsSliced"
          :key="specialist.socialSecurity"
          class="container-fluid mx-2 mb-2 bg-white"
        >
          <div class="row pt-2">
            <div class="col-sm">
              <span class="data-name">Nombre:</span>
              <p class="data">{{ specialist.specialistName }}</p>
            </div>
            <div class="col-sm">
              <span class="data-name">Número Seguro Social:</span>
              <p class="data">{{ specialist.socialSecurity }}</p>
            </div>
            <div class="col-sm">
              <span class="data-name">Especialidad(es):</span>
              <p class="data">{{ specialist.specialist_DisciplineName }}</p>
            </div>
            <div class="col-sm">
              <span class="data-name">Matricula Activa:</span>
              <p class="data">{{ specialist.activeEnrollmentCount }}</p>
            </div>
            <div
              class="col-sm-12 col-md-2 h-100 mr-3 d-flex justify-content-end mt-3"
            >
              <action-button
                v-if="
                  selectedSpecialist.indexOf(specialist.supervisedId) === -1
                "
                i="fas fa-check"
                text="Seleccionar"
                variant="outline-success"
                @click="selectSpecialist(specialist)"
              />
              <!--<label v-else class="data-name">Seleccioando</label> -->
            </div>
          </div>
        </div>
        <pagination
          v-if="unSelectedSpecialistsSliced.length > 0"
          :data="pagination"
          @pagination-go-page="pageChanged"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from '@/components/common/form/CustomDropDown';
import CustomInput from '@/components/common/form/CustomInput';
import {
  getPractitionerTypes as _getPractitionerTypes,
  getSupervisedSpecialist as _getSupervisedSpecialist,
} from '@/modules/provider/api.js';
import academicYears from '@/modules/common/academicyear.api';
import Pagination from '@/components/common/Pagination';

export default {
  name: '',
  components: {
    CustomDropDown,
    CustomInput,
    Pagination,
  },
  props: {
    onSpecialistSelected: {
      type: Function,
      default: () => undefined,
    },
    selectedSpecialist: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      practitionerTypes: [],
      practitionerTypeSelected: null,
      specialistName: '',
      ssn: '',
      specialists: [],
      count: 5,
      currentPage: 1,
    };
  },
  computed: {
    specialistId() {
      return this.$route.params.specialistId;
    },
    unSelectedSpecialistsSliced() {
      let since = (this.currentPage - 1) * this.count;
      let until = since + this.count;
      return this.unSelectedSpecialists.slice(since, until);
    },
    unSelectedSpecialists() {
      return this.specialists.filter(
        (specialist) =>
          this.selectedSpecialist.indexOf(specialist.supervisedId) === -1 &&
          (this.specialistName === null ||
            this.specialistName === '' ||
            specialist.specialistName
              .toLowerCase()
              .includes(this.specialistName.toLowerCase()))
      );
    },
    pagination() {
      return {
        currentPage: this.currentPage,
        totalItemCount: this.unSelectedSpecialists.length,
        pageCount: Math.ceil(
          (this.unSelectedSpecialists || []).length / this.count
        ),
        count:
          this.count <= this.unSelectedSpecialists.length
            ? this.count
            : this.unSelectedSpecialists.length,
      };
    },
  },
  watch: {
    unSelectedSpecialistsSliced(value) {
      if (value == 0 && this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
      }
    },
  },
  async mounted() {
    await this.getPractitionerTypes();
  },
  methods: {
    async getPractitionerTypes() {
      const { data } = await _getPractitionerTypes(
        this.specialistId,
        this.$route.params.companyId
      );
      this.practitionerTypes = data;
    },
    async getSupervisedSpecialist() {
      if (this.specialistName == null) this.specialistName = '';

      const academicYear = await this.getFiscalYear();

      const { data } = await _getSupervisedSpecialist(
        this.specialistId,
        this.practitionerTypeSelected.id,
        '',
        this.ssn,
        academicYear.id,
        1,
        999999,
        this.$route.params.companyId
      );
      this.specialists = data.data;
    },
    getTypeDescription(id) {
      const practitionerType = this.practitionerTypes.find((x) => x.id === id);
      if (practitionerType) {
        return practitionerType.name;
      }
      return '';
    },
    pageChanged(page) {
      this.currentPage = page;
    },
    selectSpecialist(specialist) {
      if (!specialist.supervisedTypeName)
        specialist.specialist.supervisedTypeName = this.getTypeDescription(
          specialist.supervisedType
        );

      this.onSpecialistSelected(specialist);
    },
    async getFiscalYear() {
      let self = this;
      const data = await academicYears.getCurrentAcademicYear().catch(() => {
        self.ShowToast('Error', 'Ocurrió un error cargando los datos', 'error');
      });

      this.academicyear = data;
      return data;
    },
  },
};
</script>
